// import React, { useEffect, useState } from "react";

// const AddressPage = () => {
//   const [addresses, setAddresses] = useState([]);
//   const [form, setForm] = useState({});

//   useEffect(() => {
//     fetchAddresses();
//   }, []);

//   const fetchAddresses = async () => {
//     const res = await fetch("https://lappyshop.onrender.com/api/get-address", {
//       credentials: "include",
//     });
//     const data = await res.json();
//     if (data.success) setAddresses(data.data);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     await fetch("https://lappyshop.onrender.com/api/add-address", {
//       method: "POST",
//       credentials: "include",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(form),
//     });

//     fetchAddresses();
//   };

//   return (
//     <div className="p-2 md:p-4">

//       <h2 className="text-lg md:text-xl font-semibold mb-4">
//         Manage Addresses
//       </h2>

//       {/* FORM */}
//       <form
//         onSubmit={handleSubmit}
//         className="grid grid-cols-1 md:grid-cols-2 gap-3 bg-white p-4 rounded-xl shadow"
//       >
//         {["fullName","phone","pincode","state","city","addressLine","landmark"].map((field) => (
//           <input
//             key={field}
//             placeholder={field}
//             className="border p-2 rounded text-sm"
//             onChange={(e) => setForm({ ...form, [field]: e.target.value })}
//           />
//         ))}

//         <button className="col-span-2 bg-black text-white py-2 rounded">
//           Add Address
//         </button>
//       </form>

//       {/* LIST */}
//       <div className="mt-4 space-y-3">
//         {addresses.map((addr) => (
//           <div key={addr._id} className="bg-white p-3 rounded shadow text-sm">
//             <p className="font-semibold">{addr.fullName}</p>
//             <p>{addr.addressLine}, {addr.city}</p>
//           </div>
//         ))}
//       </div>

//     </div>
//   );
// };

// export default AddressPage;
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaMapMarkerAlt } from "react-icons/fa";

const AddressPage = () => {
  const [addresses, setAddresses] = useState([]);
  const [form, setForm] = useState({});

  useEffect(() => {
    fetchAddresses();
  }, []);

  const fetchAddresses = async () => {
    const res = await fetch("https://lappyshop.onrender.com/api/get-address", {
      credentials: "include",
    });
    const data = await res.json();
    if (data.success) setAddresses(data.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await fetch("https://lappyshop.onrender.com/api/add-address", {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });

    setForm({});
    fetchAddresses();
  };

  return (
    <div className="w-full text-white">

      {/* 🔥 HEADER */}
      <h2 className="text-xl md:text-2xl font-bold mb-4">
        Manage Addresses
      </h2>

      {/* 🔥 FORM */}
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        onSubmit={handleSubmit}
        className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 bg-white/10 backdrop-blur-lg border border-white/20 p-4 sm:p-5 rounded-2xl shadow-lg"
      >
        {["fullName","phone","pincode","state","city","addressLine","landmark"].map((field) => (
          <input
            key={field}
            value={form[field] || ""}
            placeholder={field}
            className="w-full bg-white/10 border border-white/20 p-2 sm:p-3 rounded-lg text-sm outline-none focus:ring-2 focus:ring-green-500 placeholder:text-gray-400"
            onChange={(e) =>
              setForm({ ...form, [field]: e.target.value })
            }
          />
        ))}

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="col-span-1 sm:col-span-2 bg-gradient-to-r from-green-500 to-green-600 py-2 sm:py-3 rounded-lg font-semibold shadow-md"
        >
          Add Address
        </motion.button>
      </motion.form>

      {/* 🔥 ADDRESS LIST */}
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {addresses.map((addr) => (
          <motion.div
            key={addr._id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            whileHover={{ scale: 1.02 }}
            className="bg-white/10 backdrop-blur-lg border border-white/20 p-4 sm:p-5 rounded-xl shadow-md relative"
          >
            {/* Icon */}
            <FaMapMarkerAlt className="absolute top-3 right-3 text-green-400" />

            {/* Content */}
            <h3 className="font-semibold text-base sm:text-lg">
              {addr.fullName}
            </h3>

            <p className="text-xs sm:text-sm text-gray-300">
              {addr.phone}
            </p>

            <p className="mt-2 text-xs sm:text-sm break-words">
              {addr.addressLine}, {addr.city}, {addr.state} - {addr.pincode}
            </p>

            {addr.landmark && (
              <p className="text-xs text-gray-400 mt-1">
                Landmark: {addr.landmark}
              </p>
            )}
          </motion.div>
        ))}
      </div>

    </div>
  );
};

export default AddressPage;